(() => {
  const TT_SIZE_BANDS = [
    { key: 'newborn', label: 'Newborn / 0–12 months', maxHeight: 80, maxWeight: 11 },
    { key: '1-2', label: '1–2 years', maxHeight: 92, maxWeight: 14 },
    { key: '2-4', label: '2–4 years', maxHeight: 108, maxWeight: 21 },
    { key: '5-7', label: '5–7 years', maxHeight: 125, maxWeight: 30 },
    { key: '8-10', label: '8–10 years', maxHeight: 145, maxWeight: 42 },
    { key: '11-12', label: '11–12 years', maxHeight: 180, maxWeight: 90 }
  ];

  const recommendSizeBand = ({ height, weight, age = 'newborn', fit = 'regular' }) => {
    let index = TT_SIZE_BANDS.findIndex((band) => Number(height) > 0 && Number(height) <= band.maxHeight);
    if (index < 0) index = TT_SIZE_BANDS.findIndex((band) => band.key === age);
    if (index < 0) index = 0;
    const band = TT_SIZE_BANDS[index];
    if (Number(weight) > 0 && Number(weight) > band.maxWeight + 2 && index < TT_SIZE_BANDS.length - 1) index += 1;
    if (fit === 'relaxed' && index < TT_SIZE_BANDS.length - 1) index += 1;
    return TT_SIZE_BANDS[index];
  };

  const reveal = () => {
    const nodes = document.querySelectorAll('.tt-reveal');
    if (!('IntersectionObserver' in window)) return nodes.forEach((n) => n.classList.add('is-visible'));
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.06 });
    nodes.forEach((n) => observer.observe(n));
  };

  const initGenderShop = () => {
    document.querySelectorAll('[data-gender-tab]').forEach((button) => button.addEventListener('click', () => {
      const gender = button.dataset.genderTab;
      document.querySelectorAll('[data-gender-tab]').forEach((b) => { b.classList.toggle('is-active', b === button); b.setAttribute('aria-selected', b === button ? 'true' : 'false'); });
      document.querySelectorAll('[data-gender-panel]').forEach((panel) => { const active = panel.dataset.genderPanel === gender; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    }));
  };

  const initDrawer = () => {
    let gender = 'boys'; let age = 'newborn';
    const show = () => document.querySelectorAll('[data-drawer-panel]').forEach((panel) => {
      const active = panel.dataset.drawerPanel === `${gender}-${age}`;
      panel.hidden = !active; panel.classList.toggle('is-active', active);
    });
    document.querySelectorAll('[data-drawer-gender]').forEach((button) => button.addEventListener('click', () => {
      gender = button.dataset.drawerGender;
      document.querySelectorAll('[data-drawer-gender]').forEach((b) => b.classList.toggle('is-active', b === button));
      document.querySelectorAll('[data-drawer-section]').forEach((drawer) => drawer.dataset.drawerActiveGender = gender);
      show();
    }));
    document.querySelectorAll('[data-drawer-age]').forEach((button) => button.addEventListener('click', () => {
      age = button.dataset.drawerAge;
      document.querySelectorAll('[data-drawer-age]').forEach((b) => b.classList.toggle('is-active', b === button)); show();
    }));
  };

  const initGallery = () => {
    document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      const slides = [...gallery.querySelectorAll('[data-product-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      if (!slides.length) return;
      let index = 0;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; slide.classList.toggle('is-active', i === index); });
        thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        const current = gallery.querySelector('[data-gallery-current]'); if (current) current.textContent = String(index + 1);
      };
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.galleryThumb))));
    });
  };

  const initCartPolicy = () => {
    const checkbox = document.querySelector('[data-policy-checkbox]');
    const checkout = document.querySelector('[data-checkout-button]');
    if (!checkbox || !checkout) return;
    const sync = () => { checkout.disabled = !checkbox.checked; };
    checkbox.addEventListener('change', sync); sync();
    document.querySelector('[data-login-before-checkout]')?.addEventListener('click', () => {
      const target = encodeURIComponent('/cart');
      window.location.href = `/pages/sign-up?return_url=${target}`;
    });
  };

  const initSignupReturn = () => {
    const secureLink = document.querySelector('.tt-signup-page__existing a');
    if (!secureLink) return;
    const returnUrl = new URLSearchParams(window.location.search).get('return_url');
    if (returnUrl) secureLink.href = `${secureLink.href}${secureLink.href.includes('?') ? '&' : '?'}return_url=${encodeURIComponent(returnUrl)}`;
  };


  const initProductForm = () => {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      const form = section.querySelector('[data-product-form]');
      if (!form) return;
      const variantInput = form.querySelector('[data-product-variant-input]');
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const mobilePrice = section.querySelector('[data-mobile-price]');
      section.querySelectorAll('[data-variant-button]').forEach((button) => button.addEventListener('click', () => {
        if (button.disabled) return;
        section.querySelectorAll('[data-variant-button]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (price) price.textContent = button.dataset.variantPrice || price.textContent;
        if (mobilePrice) mobilePrice.textContent = button.dataset.variantPrice || mobilePrice.textContent;
        if (compare) {
          compare.textContent = button.dataset.variantCompare || '';
          compare.hidden = !button.dataset.variantCompare;
        }
        const mediaId = button.dataset.variantMediaId;
        if (mediaId) {
          const matchingThumb = [...section.querySelectorAll('[data-gallery-thumb][data-media-id]')].find((thumb) => thumb.dataset.mediaId === mediaId);
          matchingThumb?.click();
        }
      }));

      const quantity = form.querySelector('[data-quantity-input]');
      form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        if (!quantity) return;
        quantity.value = String(Math.max(Number(quantity.min || 1), Number(quantity.value || 1) - 1));
      });
      form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        if (!quantity) return;
        quantity.value = String(Number(quantity.value || 1) + 1);
      });
      section.querySelector('[data-mobile-add]')?.addEventListener('click', () => form.requestSubmit());
    });
  };

  const initSmartFinder = () => {
    const finder = document.querySelector('[data-smart-finder]');
    if (!finder) return;
    const openers = document.querySelectorAll('[data-smart-finder-open]');
    const closers = finder.querySelectorAll('[data-smart-finder-close]');
    const open = () => {
      finder.hidden = false;
      document.documentElement.classList.add('tt-modal-open');
      finder.querySelector('[data-smart-gender]')?.focus();
    };
    const close = () => {
      finder.hidden = true;
      document.documentElement.classList.remove('tt-modal-open');
    };
    openers.forEach((button) => button.addEventListener('click', open));
    closers.forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !finder.hidden) close(); });

    finder.querySelector('[data-smart-find]')?.addEventListener('click', () => {
      const gender = finder.querySelector('[data-smart-gender]')?.value || 'boys';
      const selectedAge = finder.querySelector('[data-smart-age]')?.value || 'newborn';
      const category = finder.querySelector('[data-smart-category]')?.value || 'socks';
      const height = finder.querySelector('[data-smart-height]')?.value || '';
      const weight = finder.querySelector('[data-smart-weight]')?.value || '';
      const fit = finder.querySelector('[data-smart-fit]')?.value || 'regular';
      const recommendation = recommendSizeBand({ height, weight, age: selectedAge, fit });
      const ageUrl = finder.getAttribute(`data-${gender}-${recommendation.key}`) || finder.getAttribute(`data-${gender}-${selectedAge}`) || finder.getAttribute(`data-${gender}-newborn`);
      const categoryUrl = finder.getAttribute(`data-${gender}-${category}`);
      const result = finder.querySelector('[data-smart-result]');
      const ageLink = finder.querySelector('[data-smart-age-link]');
      const categoryLink = finder.querySelector('[data-smart-category-link]');
      const sizeLabel = finder.querySelector('[data-smart-size-label]');
      const sizeCopy = finder.querySelector('[data-smart-size-copy]');
      if (ageLink && ageUrl) ageLink.href = ageUrl;
      if (categoryLink && categoryUrl) categoryLink.href = categoryUrl;
      if (sizeLabel) sizeLabel.textContent = `Suggested age-size: ${recommendation.label}`;
      if (sizeCopy) sizeCopy.textContent = fit === 'relaxed' ? 'A roomier fit was included in this suggestion.' : 'Use this as a starting point and compare it with the product size guide.';
      if (result) result.hidden = false;
    });
  };

  const initProductSizeFinder = () => {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      const panel = section.querySelector('[data-product-size-finder]');
      if (!panel) return;
      section.querySelector('[data-product-size-help]')?.addEventListener('click', () => { panel.hidden = false; panel.querySelector('[data-fit-height]')?.focus(); });
      section.querySelector('[data-product-size-close]')?.addEventListener('click', () => { panel.hidden = true; });
      section.querySelector('[data-fit-calculate]')?.addEventListener('click', () => {
        const recommendation = recommendSizeBand({
          height: panel.querySelector('[data-fit-height]')?.value || '',
          weight: panel.querySelector('[data-fit-weight]')?.value || '',
          age: 'newborn',
          fit: panel.querySelector('[data-fit-preference]')?.value || 'regular'
        });
        const result = panel.querySelector('[data-fit-result]');
        if (result) {
          result.innerHTML = `<strong>Suggested age-size: ${recommendation.label}</strong><span>Compare this suggestion with the product measurements before ordering.</span>`;
          result.hidden = false;
        }
      });
    });
  };

  const WISHLIST_KEY = 'twinkleWishlistV1';
  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (_) { return []; }
  };
  const setWishlist = (items) => localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EGP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents || 0) / 100); }
    catch (_) { return `${Number(cents || 0) / 100} ${currency}`; }
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[char]));
  const showWishlistToast = (message) => {
    let toast = document.querySelector('[data-wishlist-toast]');
    if (!toast) { toast = document.createElement('div'); toast.className = 'tt-wishlist-toast'; toast.dataset.wishlistToast = ''; document.body.appendChild(toast); }
    toast.innerHTML = `${escapeHtml(message)} <a href="/pages/wishlist">View wishlist</a>`;
    toast.classList.add('is-visible');
    clearTimeout(toast._ttTimer); toast._ttTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };
  const syncWishlistButtons = () => {
    const handles = new Set(getWishlist().map((item) => item.handle));
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const saved = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  };
  const initWishlist = () => {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist-toggle]');
      if (!button) return;
      event.preventDefault(); event.stopPropagation();
      const handle = button.dataset.productHandle;
      if (!handle) return;
      const items = getWishlist();
      const index = items.findIndex((item) => item.handle === handle);
      if (index >= 0) { items.splice(index, 1); showWishlistToast('Removed from wishlist.'); }
      else {
        items.unshift({ handle, title: button.dataset.productTitle || '', url: button.dataset.productUrl || `/products/${handle}`, image: button.dataset.productImage || '' });
        showWishlistToast('Saved to your wishlist.');
      }
      setWishlist(items); syncWishlistButtons(); renderWishlistPage();
    });
    syncWishlistButtons();
  };
  const renderWishlistPage = async () => {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    const items = getWishlist();
    grid.innerHTML = '';
    if (!items.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    const root = window.Shopify?.routes?.root || '/';
    const products = await Promise.all(items.map(async (item) => {
      try { const response = await fetch(`${root}products/${encodeURIComponent(item.handle)}.js`); if (!response.ok) throw new Error(); return { ...item, product: await response.json() }; }
      catch (_) { return { ...item, product: null }; }
    }));
    products.forEach(({ handle, title, url, image, product }) => {
      const productTitle = product?.title || title;
      const productUrl = product?.url || url || `/products/${handle}`;
      const productImage = product?.featured_image || image;
      const price = product ? formatMoney(product.price) : '';
      const article = document.createElement('article');
      article.className = 'tt-product-card tt-wishlist-card';
      article.innerHTML = `<button type="button" class="tt-wishlist-remove" data-wishlist-toggle data-product-handle="${escapeHtml(handle)}" aria-label="Remove ${escapeHtml(productTitle)}">×</button><a class="tt-product-card__media" href="${escapeHtml(productUrl)}">${productImage ? `<img src="${escapeHtml(productImage)}" alt="${escapeHtml(productTitle)}" loading="lazy">` : ''}</a><div class="tt-product-card__body"><a href="${escapeHtml(productUrl)}"><h3>${escapeHtml(productTitle)}</h3></a>${price ? `<p class="tt-product-price">${escapeHtml(price)}</p>` : ''}<a class="tt-product-action" href="${escapeHtml(productUrl)}">View product</a></div>`;
      grid.appendChild(article);
    });
  };

  const initGiftCardRecipient = () => {
    document.querySelectorAll('[data-gift-card-recipient]').forEach((wrapper) => {
      const toggle = wrapper.querySelector('[data-gift-card-toggle]');
      const fields = wrapper.querySelector('[data-gift-card-fields]');
      const offset = wrapper.querySelector('[data-gift-card-offset]');
      const sendDate = wrapper.querySelector('[data-gift-card-send-date]');
      if (!toggle || !fields) return;
      const sync = () => {
        fields.hidden = !toggle.checked;
        fields.querySelectorAll('input, textarea, select').forEach((field) => { field.disabled = !toggle.checked; });
        const required = wrapper.querySelector('[data-gift-card-required]');
        if (required) required.required = toggle.checked;
        if (offset && toggle.checked) offset.value = String(new Date().getTimezoneOffset());
      };
      if (sendDate) sendDate.min = new Date().toISOString().slice(0,10);
      toggle.addEventListener('change', sync); sync();
    });
  };

  const initGiftOrder = () => {
    const toggle = document.querySelector('[data-gift-order-toggle]');
    const fields = document.querySelector('[data-gift-order-fields]');
    if (!toggle || !fields) return;
    const deliveryDate = fields.querySelector('[data-gift-delivery-date]');
    if (deliveryDate) deliveryDate.min = new Date().toISOString().slice(0,10);
    const sync = () => {
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('[data-gift-order-required]').forEach((field) => { field.required = toggle.checked; });
    };
    toggle.addEventListener('change', sync); sync();
  };



  const initHeroSlider = () => {
    document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
      const slides = [...slider.querySelectorAll('[data-hero-slide]')];
      const dots = [...slider.querySelectorAll('[data-hero-dot]')];
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const seconds = Math.max(4, Number(slider.dataset.autoplaySeconds || 6));
      const autoplayEnabled = slider.dataset.autoplay !== 'false';
      const pauseButton = slider.querySelector('[data-hero-pause]');
      const pauseIcon = slider.querySelector('[data-hero-pause-icon]');
      const pauseLabel = slider.querySelector('[data-hero-pause-label]');
      let manuallyPaused = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (next, userInitiated = false) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('a, button, input, select, textarea').forEach((node) => { node.tabIndex = active ? 0 : -1; });
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (userInitiated) restart();
      };
      const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
      const start = () => {
        if (!autoplayEnabled || manuallyPaused || reducedMotion || document.hidden) return;
        stop();
        timer = window.setInterval(() => show(index + 1), seconds * 1000);
      };
      const restart = () => { stop(); start(); };
      slider.querySelector('[data-hero-prev]')?.addEventListener('click', () => show(index - 1, true));
      slider.querySelector('[data-hero-next]')?.addEventListener('click', () => show(index + 1, true));
      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.heroDot), true)));
      pauseButton?.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        pauseButton.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');
        pauseButton.setAttribute('aria-label', manuallyPaused ? 'Resume automatic banner rotation' : 'Pause automatic banner rotation');
        if (pauseIcon) pauseIcon.textContent = manuallyPaused ? '▶' : 'Ⅱ';
        if (pauseLabel) pauseLabel.textContent = manuallyPaused ? 'Resume automatic banner rotation' : 'Pause automatic banner rotation';
        manuallyPaused ? stop() : start();
      });
      if (!autoplayEnabled || reducedMotion) {
        manuallyPaused = true;
        if (pauseButton) {
          pauseButton.setAttribute('aria-pressed', 'true');
          pauseButton.setAttribute('aria-label', 'Resume automatic banner rotation');
          if (pauseIcon) pauseIcon.textContent = '▶';
          if (pauseLabel) pauseLabel.textContent = 'Resume automatic banner rotation';
        }
      }
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', (event) => { if (!slider.contains(event.relatedTarget)) start(); });
      document.addEventListener('visibilitychange', () => { document.hidden ? stop() : start(); });
      show(0);
      start();
    });
  };

  const initMenus = () => {
    document.addEventListener('click', (event) => {
      document.querySelectorAll('.tt-nav-dropdown[open], .tt-mobile-menu[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
    });
  };

  document.addEventListener('DOMContentLoaded', () => { initHeroSlider(); reveal(); initGenderShop(); initDrawer(); initGallery(); initCartPolicy(); initSignupReturn(); initProductForm(); initSmartFinder(); initProductSizeFinder(); initGiftCardRecipient(); initGiftOrder(); initWishlist(); renderWishlistPage(); initMenus(); });
})();
